import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import './LeaderBoard.css';
import type { ChallengeTypeApi } from '../../types/api/challenges';
import type { ChallengeLeaderEntryRedux } from '../../types/models/challenges';

import BoardList from './BoardList';
import TopLeaders from './TopLeaders';

const EMPTY_LEADERS = [0, 1, 2];

interface LeaderBoardProps {
  isActive: boolean | null;
  isChallengeUnavailable: boolean;
  handleToggle: () => void;
  isOn: boolean;
  leaders: ChallengeLeaderEntryRedux[];
  users: ChallengeLeaderEntryRedux[];
  challengeType: ChallengeTypeApi | string;
  userPlace: number | undefined;
  buttonText: string;
  handleButtonClick: () => void;
}

function LeaderBoard({
  isActive,
  isChallengeUnavailable,
  handleToggle,
  isOn,
  leaders,
  users,
  challengeType,
  userPlace,
  buttonText,
  handleButtonClick,
}: LeaderBoardProps) {
  const { t } = useTranslation();
  const [dataToMap, setDataToMap] = useState<ChallengeLeaderEntryRedux[] | number[]>(EMPTY_LEADERS);

  useEffect(() => {
    if (leaders.length > 0) {
      setDataToMap(leaders);
    } else {
      setDataToMap(EMPTY_LEADERS);
    }
  }, [leaders]);

  return (
    <div
      className={`chart-container leaderboard tile half ${
        isActive || isChallengeUnavailable ? 'active' : 'inactive'
      }`}
      role="group"
      aria-label={`${t('challenge.leaderboard.title')}`}
    >
      <div className="title-container leader-board">
        <h3 className="title">{t('challenge.leaderboard.title')}</h3>
        {isActive && (
          <div className="switcher-container">
            {' '}
            <p className="subtitle">{t('challenge.leaderboard.switch.label')}</p>
            <div className="">
              <label
                htmlFor="leaderboard-consent-toggle"
                className={`whc-switch ${isOn ? 'on' : 'off'}`}
                aria-label={`${t('challenge.leaderboard.title')} ${t('challenge.leaderboard.switch.label')} ${isOn ? t('leaderboard.switch.on') : t('leaderboard.switch.off')}`}
              >
                <input
                  id="leaderboard-consent-toggle"
                  type="checkbox"
                  checked={isOn}
                  onChange={handleToggle}
                  className="whc-switch-input visuallyHidden"
                />
                <div className="whc-slider-button" />
              </label>
            </div>
          </div>
        )}
      </div>
      <div className="leaders-content-wrapper fs-mask">
        <TopLeaders
          dataToMap={dataToMap}
          challengeType={challengeType}
          leadersNumber={leaders.length}
          buttonText={buttonText}
          isActive={isActive}
          handleButtonClick={handleButtonClick}
        />
        {users.length === 0 ? (
          <div className="leaders-noleaders">
            {isChallengeUnavailable
              ? t('challenge.leaderboard.inactive')
              : t('challenge.leaderboard.empty')}
          </div>
        ) : (
          <BoardList
            users={users}
            challengeType={challengeType}
            userPlace={userPlace}
            leaders={leaders}
          />
        )}
      </div>
    </div>
  );
}

export default LeaderBoard;
